<!-- @format -->
<div class="hmf-flex-column hmf-align-items-center">
	<div class="hmf-header-bold-s hmf-mb-xxxs hmf-text-align-center">{{title()}}</div>
	@for(product of productRecommendationsList | slice:0:4 ; track $index) {
		<hmf-product-card
			class="hmf-my-xxxs"
			[productData]="product"
			[size]="'small'"
			[showATC]="false"
			variant="recommendation"
			(cardClicked)="handleProductCardClicked(product)">
		</hmf-product-card>
	}
	<button
	hmf-action-text
	variant="secondary"
	(click)="openDrawer()"
	>
	View More
	</button>
</div>

<ng-template #recDrawerContent>
	<div class="hmf-display-flex hmf-flex-row hmf-flex-wrap hmf-justify-content-center rec-drawer-content">
		@for(product of productRecommendationsList; track $index) {
			<hmf-product-card
				class="hmf-my-xxxs"
				[productData]="product"
				[size]="'medium'"
				[showATC]="false"
				variant="recommendation"
				(cardClicked)="handleProductCardClicked(product)">
			</hmf-product-card>
		}
	</div>
</ng-template>

